import access from './access.route'
import admin from './admin.route'
import page from './page.route'
import test from './test.route'
import dictresult from './dictresult.route'

import NotFound from '@/pages/common/NotFoundPage.vue'
const Home = () => import('@/layouts/HomeLayout.vue')


const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      label : "Главная",
      title : "Главная"
    },
    component: Home,
    alias: ['/home', '/index']
  },
  {
    path: '*', 
    component: NotFound
  },
  access,
  admin,
  page,
  test,
  dictresult
]

export default routes
